import { Card, Timeline, Typography, Button } from "antd";
//import React, { useMemo } from "react";
import Minter from "./Minter";
import MintNFT from "./MintNft";
import PoweredLogo from "components/PoweredLogo";

import GiveawayNFT from "./GiveawayNFT";
import GiveAwayButton from "./GiveAwayButton";

//import MintNFT from "./MintNft";

const { Text } = Typography;

const styles = {
  contentnft: {
    display: "flex",
    paddingBottom: "25px",
    paddingLeft: "15px",
    paddingRight: "15px",
    gap: "25px",
    marginTop: "-30px",
  },

  title: {
    fontSize: "14px",
    fontWeight: "700",
    color: "white",
    fontFamily: "verdana",
    textTransform: "uppercase",
  },
  itemdot: {
    fontWeight: "600",
    fontSize: "17px",
  },
  text: {
    fontSize: "12px",
    fontWeight: "400",
    color: "white",
    fontFamily: "verdana",
    textTransform: "uppercase",
  },
  poweredby: {
    marginTop: "25px",
    marginBottom: "5px",
    textAlign: "center",
    fontSize: "16px",
    fontWeight: "400",
    color: "#2655DD",
  },
  card: {
    color: "white",
    boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
    border: "0px solid transparent",
    borderRadius: "0.5rem",
    background:
      "linear-gradient(222deg, rgb(31, 32, 48) 0%, rgba(26,27,38,1) 31%, rgb(30, 32, 44) 54%, rgba(26,26,37,1) 100%)",
  },
  timeline: {
    marginBottom: "-45px",
    color: "white",
  },
};

export const Powered = () => (
  <div style={styles.Container}>
    <PoweredLogo image="https://storageapi.fleek.co/65baa672-f449-45c2-ab44-13cf8312b581-bucket/powered.png" />
  </div>
);

export default function NFTMint() {
  return (
    <div style={styles.contentnft}>
      <Card
        style={styles.card}
        title={
          <>
            💎 <Text style={styles.title}>Mint This Awesome NFT</Text>
          </>
        }
      >
        <MintNFT />
      </Card>

      <Card
        style={styles.card}
        title={
          <>
            <Text style={styles.title}>Lorem ipsum dolor sit amet!</Text>
          </>
        }
      >
        <Timeline mode="center" style={styles.timeline}>
          <Minter />
          <div style={styles.poweredby}>
            <Text style={styles.title}>Powered By</Text>
          </div>
          <Powered />
          <GiveawayNFT />
          <GiveAwayButton />
        </Timeline>
      </Card>

      <div>
        <Card
          style={{ marginTop: "0px", ...styles.card }}
          title={
            <>
              {" "}
              <Text style={styles.title}>How does it work? </Text>
            </>
          }
        >
          <Timeline mode="left" style={styles.timeline}>
            <Timeline.Item dot="1" style={styles.itemdot}>
              <Text style={styles.text}>
                <b>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.{" "}
                </b>
              </Text>
            </Timeline.Item>
            <Timeline.Item dot="2" style={styles.itemdot}>
              <Text style={styles.text}>
                <b>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.{" "}
                </b>
              </Text>
            </Timeline.Item>
            <Timeline.Item dot="3" style={styles.itemdot}>
              <Text style={styles.text}>
                <b>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.{" "}
                </b>
              </Text>
            </Timeline.Item>
            <Timeline.Item dot="4" style={styles.itemdot}>
              <Text style={styles.text}>
                <b>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt
                </b>
                , <b>ut labore et dolore magna aliqua. </b>{" "}
              </Text>
            </Timeline.Item>
          </Timeline>
        </Card>

        <Card
          style={{ marginTop: "20px", ...styles.card }}
          title={
            <>
              💎{" "}
              <Text style={styles.title}>
                {" "}
                Why should anyone hold This Awesome NFTs ?
              </Text>
            </>
          }
        >
          <Timeline mode="left" style={styles.timeline}>
            <Timeline.Item dot="1" style={styles.itemdot}>
              <Text style={styles.text}>
                <b>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt
                </b>
                , <b>ut labore et dolore magna aliqua. </b>{" "}
              </Text>
            </Timeline.Item>
            <Timeline.Item dot="2" style={styles.itemdot}>
              <Text style={styles.text}>
                <b>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.{" "}
                </b>{" "}
              </Text>
            </Timeline.Item>
            <Timeline.Item dot="3" style={styles.itemdot}>
              <Text style={styles.text}>
                <b>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.{" "}
                </b>{" "}
              </Text>
            </Timeline.Item>
            <Timeline.Item dot="4" style={styles.itemdot}>
              <Text style={styles.text}>
                <b>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.{" "}
                </b>
              </Text>
            </Timeline.Item>
          </Timeline>
        </Card>
      </div>
    </div>
  );
}
